import React from "react";

import { SearchField } from "@mapmycustomers/ui";

import styles from "./SearchBox.module.scss";

interface Props {
  onChange?: (query: string) => void;
  placeholder?: string;
}

const SearchBox: React.FC<Props> = ({ onChange, placeholder }) => {
  return (
    <div className={styles.container}>
      <SearchField allowClear onChange={onChange} placeholder={placeholder} size="large" />
    </div>
  );
};

export default SearchBox;
